export const CookieConstantes = {
  COOKIE_CORRESPONDANT: "CERBA_CORRESPONDANT",
  COOKIE_AUTH: "CERBA_AUTHENTIFICATION",
  COOKIE_ORIGINALE_AUTH: "CERBA_ORIGINALE_AUTHENTIFICATION",
  COOKIE_ORIGINAL : "CERBA_ORIGINAL_AUTHENTIFICATION",
  UPDATE_PASSWORD_ALERT_COOKIE : "UPDATE_PASSWORD_ALERT"
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/constantes/cookie.constantes.ts